<template>
  <div v-if="show" class="job-status-history">
    <div class="container-line job-status-line">
      <div class="line-label">{{ $t(`${i18nPrefix}.label.jobStatus`) }}</div>
      <div class="line-content">
        <el-radio-group v-model="stepData.status" class="status-radio-group" :disabled="!hasCloseJobPermission || disabled">
          <el-radio
            v-for="(value, typeName) in JOB_STATUS_TYPE"
            :key="typeName"
            :label="value"
          >
            {{ $t(`${i18nPrefix}.btn.jobStatus.${typeName}`) }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="container-line apply-url-line">
      <div class="line-label">{{ $t(`${i18nPrefix}.label.applyUrl`) }}</div>
      <div class="line-content">
        <div class="apply-url">{{ stepData.applyUrl }}</div>
        <div
          v-clipboard:copy="stepData.applyUrl"
          v-clipboard:success="handleCopySuccess"
          v-clipboard:error="handleCopyError"
          class="copy-btn"
        >
          <i class="el-icon-document-copy"></i>
        </div>
      </div>
    </div>
    <div class="container-line history-line">
      <div class="line-label">{{ $t(`${i18nPrefix}.label.statusHistory`) }}</div>
      <div class="line-content">
        <div class="history-list">
          <div
            v-for="(history) in stepData.historyList"
            class="history"
            :key="history.id"
          >
            <span class="status">{{ $t(`${i18nPrefix}.jobStatus.${getHistoryStatusName(history.status, history.old_status)}`) }}</span>
            <span class="operator">{{ history.operator }}</span>
            <span class="operator-company">{{ history.operatorCompanyName }}</span>
            <span class="operate-time">{{ history.operator_time|formatDateTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mixin from './mixin'
import { addI18nProperty } from '@/i18n'
import { JOB_STATUS_TYPE } from '@/constant/job'

export default {
  mixins: [mixin],
  data () {
    return {
      JOB_STATUS_TYPE,
      hasForm: false
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getHistoryStatusName (status, oldStatus) {
      if (status === 'create') {
        return 'CREATE'
      } else {
        if (status === oldStatus) {
          return 'REFRESH'
        }
        return _.findKey(JOB_STATUS_TYPE, value => value === status)
      }
    },
    handleCopySuccess () {
      this.$message.success(this.$t(`${this.i18nPrefix}.message.copyApplyUrl.success`))
    },
    handleCopyError () {
      this.$message.error(this.$t(`${this.i18nPrefix}.message.copyApplyUrl.fail`))
    },
    setStepDataToJobInfo () {
      const stepData = this.stepData
      const jobInfo = this.jobInfo
      this.$set(jobInfo, 'status', stepData.status)
    },
    async getStepData () {
      const jobInfo = this.jobInfo
      const stepData = {
        status: jobInfo.status,
        applyUrl: `${window.location.origin}/a/${jobInfo.short_unique_id}/`,
        historyList: _.map(jobInfo.job_status_histories, history => {
          addI18nProperty(history, 'operatorCompanyName', 'operator_company_cn_name', 'operator_company_name')
          return history
        })
      }
      return stepData
    }
  }
}
</script>

<style lang="scss" scoped>
.job-status-history {
  font-size: 14px;

  .container-line {
    display: flex;
    align-items: center;

    + .container-line {
      margin-top: 22px;
    }

    .line-label {
      width: 200px;
      flex-shrink: 0;
      padding-right: 20px;
      line-height: 32px;
      color: #606266;
    }

    .line-content {
      flex: 1;
    }
  }

  .apply-url-line {
    .line-content {
      display: flex;
      overflow: hidden;

      .apply-url {
        margin-right: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .copy-btn {
        margin-left: 10px;
        margin-right: 0;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
      }
    }
  }

  .history-line {
    display: block;

    .history-list {
      .history {
        display: flex;
        padding: 15px 0;
        justify-content: space-between;
        border-bottom: 1px dashed #8a8a8a;

        > * {
          text-align: center;
        }

        .status {
          width: 10%;
        }

        .operator {
          width: 32%;
        }

        .operator-company {
          width: 32%;
        }

        .operate-time {
          width: 25%;
        }
      }
    }
  }
}
</style>
